import React from 'react';
import { PiArrowsLeftRight } from 'react-icons/pi';

import { Tooltip } from 'antd';
import { COPY_TOOL_SWAP_LABEL } from 'constants/uiConstants';

interface SwapButtonProps {
  onSwap: () => void;
  disabled?: boolean;
  /** Shown in the tooltip instead of the label when swap isn't available. */
  disabledReason?: string;
}

/** Sits between the panels and exchanges their settings and selections. */
const SwapButton: React.FC<SwapButtonProps> = ({
  onSwap,
  disabled,
  disabledReason,
}) => (
  <Tooltip title={disabledReason ?? COPY_TOOL_SWAP_LABEL}>
    {/* A disabled button fires no mouse events, so the tooltip needs a wrapper. */}
    <span className="inline-flex self-center">
      <button
        type="button"
        aria-label={COPY_TOOL_SWAP_LABEL}
        onClick={onSwap}
        disabled={disabled}
        className="flex h-10 w-10 flex-shrink-0 items-center justify-center self-center rounded-full border border-gray-medium bg-white text-charcoal transition-colors hover:bg-rowHover focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50"
      >
        <PiArrowsLeftRight size={20} className="rotate-90 md:rotate-0" />
      </button>
    </span>
  </Tooltip>
);

export default SwapButton;
